// Lot 9 — Historique des versions (V1, V2, V3…), en lecture seule : motif,
// date, état, canaux de sortie (app / PDF), notification. L'aperçu d'une
// version est RECALCULÉ depuis la fiche actuelle : il n'est dit identique à ce
// que la cliente a reçu que si son empreinte égale celle du livrable validé
// et publié ; sinon il est signalé comme pouvant différer. Rien n'y est
// modifiable.

import { useState } from 'react';
import { ApercuApplication } from '../ClientAppPreviewModal';
import { lignesHistorique, mentionApercu } from './suiviEcran';
import { construireLivrableApp, empreinteLivrable, ligneTelleQuePubliee } from './services/suiviControle';
import { lireEmpreinteValidee, lireVersion } from './services/suiviVersions';

export default function Historique({ client, versions = [], db, lire = lireVersion, lireEmpreinte = lireEmpreinteValidee }) {
  const [ouverte, setOuverte] = useState(null);
  const lignes = lignesHistorique(versions);
  if (lignes.length === 0) return null;

  async function ouvrir(l) {
    const id = l.id;
    setOuverte({ id, chargement: true });
    try {
      const options = db ? { db } : {};
      const ligne = await lire(id, options);
      let payload = null;
      let recalculee = null;
      try {
        payload = construireLivrableApp(client, ligneTelleQuePubliee(ligne));
        recalculee = await empreinteLivrable(payload);
      } catch {
        payload = null;
      }
      let attendue = null;
      try {
        attendue = (await lireEmpreinte(id, options))
          || ligne?.client_app_publication?.artifact_sha256
          || ligne?.client_app_publication?.publication_artifact_sha256
          || null;
      } catch {
        attendue = null;
      }
      setOuverte({ id, ligne, payload, mention: mentionApercu({ etat: l.etatCode, attendue, recalculee }) });
    } catch (error) {
      setOuverte({ id, erreur: error?.message || 'Cette version n’a pas pu être ouverte.' });
    }
  }

  return (
    <details className="jrn-drawer suivi-historique">
      <summary className="jrn-drawer__summary">Historique des versions</summary>
      <ul className="jrn-drawer__body">
        {lignes.map((l) => (
          <li key={l.id}>
            <strong>{l.nom}</strong> · {l.motif} · {l.etat}{l.date ? ` · ${l.date}` : ''}
            {l.canaux.length > 0 && ` · ${l.canaux.join(' et ')}`}
            {l.notification && ` · ${l.notification}`}
            {l.ouvrable && (
              <>
                {' '}
                <button type="button" className="jrn-btn jrn-btn--ghost" onClick={() => (ouverte?.id === l.id ? setOuverte(null) : ouvrir(l))}>
                  {ouverte?.id === l.id ? 'Fermer' : 'Ouvrir'}
                </button>
              </>
            )}
            {ouverte?.id === l.id && (
              <div className="suivi-historique__version">
                {ouverte.chargement && <p className="jrn-block__intro">Chargement…</p>}
                {ouverte.erreur && <p className="jrn-error" role="alert">{ouverte.erreur}</p>}
                {ouverte.ligne && <VersionLue client={client} ligne={ouverte.ligne} payload={ouverte.payload} mention={ouverte.mention} />}
              </div>
            )}
          </li>
        ))}
      </ul>
    </details>
  );
}

/** Une version ouverte : mention d'exactitude, aperçu sans bouton, plan. */
export function VersionLue({ client, ligne, payload, mention }) {
  return (
    <>
      <p className="jrn-meta-chip">Lecture seule · {mention}</p>
      {payload && <ApercuApplication client={client} payload={payload} consultation={ligne} />}
      <h4 className="jrn-label">Plan</h4>
      <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', margin: 0 }}>{ligne.nutrition_plan || ''}</pre>
    </>
  );
}
